import { I18nProvider } from "@refinedev/core";
import { useTranslation } from "react-i18next";

export const useI18nProvider = (): I18nProvider => {
  const { t, i18n } = useTranslation();

  return {
    translate: (key: string, params?: Record<string, unknown>) => t(key, params),
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };
};
